import { TRAINING_ROUTES, trainingConfigOutput, } from "@repo/contract/training";
import { profileKeys } from "./keys";
import { readSection, sectionMutation, sectionOptions, writeSection, } from "./section";
/**
 * Goal, days, session length and experience (`D115`).
 *
 * `GET` answers `404 training_config.not_found` until one is stored. `level`
 * is derived by the server and exists only on the output.
 */
const spec = {
    key: profileKeys.trainingConfig,
    name: "training-config",
    output: trainingConfigOutput,
    path: TRAINING_ROUTES.trainingConfig,
};
/** `GET /me/training-config`. */
export function fetchTrainingConfig(api, init) {
    return readSection(api, spec, init);
}
/** `PUT /me/training-config` — replaces the whole section; answers what is now stored. */
export function putTrainingConfig(api, input) {
    return writeSection(api, spec, input);
}
export function trainingConfigOptions(api) {
    return sectionOptions(api, spec);
}
export function trainingConfigMutation(api) {
    return sectionMutation(api, spec);
}
//# sourceMappingURL=training-config.js.map